var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.type == 'title')?_c('div',{staticClass:"item-title"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.formatTitle(_vm.item.content))}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }